import { Text, Title } from '@mantine/core';
import './styles.scss';

interface DisplayFieldProps {
  title: string;
  content: React.ReactNode;
}

const DisplayField = ({ title: text, content }: DisplayFieldProps) => {
  return (
    <>
      <Text>{text}</Text>
      <Title>{content}</Title>
    </>
  );
};

export default DisplayField;
